import AddUserInfo from 'components/emptyLeg/AddUserInfo';
import InquireDialog from 'components/emptyLeg/InquireDialog';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import store from 'redux/store';
import { userInquire } from 'services';
import {
  clearSessionStorage,
  divisionNumber,
  formatUtcDate,
  getLocalStorage,
  getSessionStorage,
  setSessionStorage,
} from 'untils/auth';
import { tapLead } from 'untils/tracking';

export default function FeaturedFlights({
  roundtrip,
  scheduleList,
  emptyLegList,
  passengerNumber,
  timeName,
  timeOnceName,
  fromValue,
  toValue,
}) {
  const history = useHistory();
  const weekDate = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const [addUserInfoShow, setAddUserInfoShow] = useState(false);
  const [currentParams, setCurrentParams] = useState({});
  const [dialogType, setDialogType] = useState('');
  const [dialogContent, setDialogContent] = useState(''); //
  const [sourceMenuShow, setSourceMenuShow] = useState(false); // 用户来源渠道
  const [inquireId, setInquireId] = useState('false');
  const [routerId, setRouterId] = useState(''); //
  const [sharedList, setSharedList] = useState([]); // 定期航班列表
  const [inquireType, setInquireTpe] = useState('');

  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      let inquireSubmit = store.getState().getEmptyLegChange;
      if (inquireSubmit) {
        submitInquire(inquireType);
        store.dispatch({
          type: 'emptyLegClear',
        });
      }
    });
    let departList = scheduleList.departure;
    let returnList = scheduleList.return;
    if (roundtrip) {
      if (departList && returnList) {
        let result = departList.filter((departure) => {
          return returnList.some((returnTrip) => {
            return (
              departure.fromCity === returnTrip.endCity && departure.endCity === returnTrip.fromCity
            );
          });
        });
        setSharedList(result);
      }
    } else {
      setSharedList(scheduleList.departure);
    }
    return () => {
      clearSessionStorage('eptData');
      unsubscribe();
    };
  }, [scheduleList, roundtrip]);

  // 提交inquire
  const submitInquire = (type) => {
    let emptyLegDetail = '';
    let date = '';
    let time = '';
    let timezone = '';
    setInquireTpe(type);
    let params = getSessionStorage('eptData') ? JSON.parse(getSessionStorage('eptData')) : {};
    let userFormData = getSessionStorage('userFormData')
      ? JSON.parse(getSessionStorage('userFormData'))
      : '';
    if (Object.keys(params).length <= 0) {
      if (type === 'depart') {
        emptyLegDetail = emptyLegList?.departure?.recommend;
        date = userFormData.dateStart;
        time = timeName;
        timezone = fromValue.timezone;
      } else {
        emptyLegDetail = emptyLegList?.return?.recommend;
        date = userFormData.dateEnd;
        time = timeOnceName;
        timezone = toValue.timezone;
      }
      params = {
        emptyLegID: emptyLegDetail?.emptyId,
        passengers: passengerNumber,
        startAirportId: emptyLegDetail?.startAirportId,
        endAirportId: emptyLegDetail?.endAirportId,
        departureDate: formatUtcDate(date + ' ' + time, timezone),
      };
      setSessionStorage('eptData', JSON.stringify(params));
    }
    if (getLocalStorage('token')) {
      let user = getLocalStorage('user') ? JSON.parse(getLocalStorage('user')) : {};
      let userId = getLocalStorage('userId');
      params['userID'] = userId;
      params['name'] = user.name;
      params['email'] = user.account;
      if (user.phone) params['phone'] = user.phone;
      if (user.phoneCode) params['phoneCode'] = user.phoneCode;
      submitInquireAjax(params);
    } else {
      setAddUserInfoShow(true);
      setCurrentParams(params);
    }
  };

  //提交inquire
  const submitInquireAjax = (param) => {
    if (param.emptyLegID && param.departureDate && param.passengers && param.email && param.name) {
      userInquire(param).then((res) => {
        if (res.code || (!res.code && res.msg.indexOf('Inquire Repeat') > -1)) {
          setRouterId(res.data.RouterID);
          // 首次提交和重复提交
          if (res.msg.indexOf('Inquire Repeat') > -1) {
            setDialogContent('This request has been submitted, please do not submit it again!');
            setSourceMenuShow(false);
          } else {
            setDialogContent('Your inquiry has been successfully submitted.');
            setSourceMenuShow(true);
            setInquireId(res.data.InquireID);
            tapLead({ userId: param.userID, InquireID: res.data.InquireID });
          }
          showDialogHandle();
        }
      });
    }
  };
  // 显示弹窗操作
  const showDialogHandle = () => {
    let user = getLocalStorage('user') ? JSON.parse(getLocalStorage('user')) : {};
    getLocalStorage('token') && !user.phone
      ? setDialogType('phoneModle')
      : setDialogType('repeatModle');
  };

  // 跳转定期航班搜索结果页
  const searchShared = (item) => {
    let userFormData = getSessionStorage('userFormData')
      ? JSON.parse(getSessionStorage('userFormData'))
      : '';
    const type = roundtrip ? 'roundTrip' : 'oneWay';
    const reg = /[-/\\]/g;
    let city = `${item.fromCity.replace(reg, '_')}-${item.endCity.replace(reg, '_')}`;
    city = city.replace(/\s/g, '');
    let goTime = moment(new Date(userFormData.dateStart)).format('YYYYMMDD');
    let backTime = moment(new Date(userFormData.dateEnd)).format('YYYYMMDD');
    let passenger = passengerNumber;
    history.push({
      pathname: `/searchDetails/${type}/${passenger}/${city}/${
        roundtrip ? `${goTime}-${backTime}` : goTime
      }`,
      state: 'charter',
    });
  };

  const closeDialogHandle = () => {
    setDialogType('');
    setAddUserInfoShow(false);
  };

  return (
    <div className="featured">
      <h1>Featured Flights</h1>
      <p>* Airacer recommends you more special flights on the date, before or after.</p>
      {/* Shared Flights */}
      {sharedList?.length > 0 ? (
        <div className="shared-flights">
          <h3>Shared Flights</h3>
          {sharedList.map((item, index) => {
            return (
              <div key={index} className="shared-list">
                <div>
                  <div className="city">
                    <span>{item.fromCity}</span>
                    <i className={`bg-image ${roundtrip ? 'active' : ''} `}></i>
                    <span>{item.endCity}</span>
                  </div>
                  <div className="date-week">
                    {weekDate.map((day) => {
                      return (
                        <span
                          key={day}
                          className={`${item.plan?.indexOf(day) > -1 ? '' : 'active'}`}
                        >
                          {day[0]}
                        </span>
                      );
                    })}
                  </div>
                </div>
                <div className="shared-price">
                  <i className="bg-image"></i>
                  <span>
                    From<b>${divisionNumber(item.priceRange?.split('/')[0]) || 0}</b>
                  </span>
                  <button onClick={() => searchShared(item)}>Book</button>
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
      {/* Empty Legs */}
      {emptyLegList?.departure ? (
        <div>
          <h3>Empty Legs {roundtrip ? '- Depart' : ''}</h3>
          <div className="empty-list">
            <div>
              <div className="city">
                <span>
                  {emptyLegList.StartCity.City}, {emptyLegList.StartCity.country}
                </span>
                <i className="bg-image"></i>
                <span>
                  {emptyLegList.EndCity.City}, {emptyLegList.EndCity.country}
                </span>
              </div>
              <div className="date-seat">
                <span>{emptyLegList.departure.TimeRange}</span>
                <span>
                  Aircraft: <span className="plane-type">{emptyLegList.departure.Aircraft}</span>,
                  etc
                </span>
                <span>
                  Seats:{' '}
                  {emptyLegList.departure.SeatsRange.includes('-')
                    ? emptyLegList.departure.SeatsRange.split('-')[0] ===
                      emptyLegList.departure.SeatsRange.split('-')[1]
                      ? emptyLegList.departure.SeatsRange.split('-')[0]
                      : emptyLegList.departure.SeatsRange
                    : ''}
                </span>
              </div>
            </div>
            <div className="empty-price">
              <i className="bg-image"></i>
              {emptyLegList.departure.Price ? (
                <span>
                  From<b>${divisionNumber(emptyLegList.departure.Price)}</b>
                </span>
              ) : (
                <span>
                  <b>Ask for Price</b>
                </span>
              )}
              <button onClick={() => submitInquire('depart')}>Inquire</button>
            </div>
          </div>
        </div>
      ) : null}
      {emptyLegList?.return ? (
        <div className="empty-return">
          <h3>Empty Legs - Return</h3>
          <div className="empty-list">
            <div>
              <div className="city">
                <span>
                  {emptyLegList.EndCity.City}, {emptyLegList.EndCity.country}
                </span>
                <i className="bg-image"></i>
                <span>
                  {emptyLegList.StartCity.City}, {emptyLegList.StartCity.country}
                </span>
              </div>
              <div className="date-seat">
                <span>{emptyLegList.return.TimeRange}</span>
                <span>
                  Aircraft: <span className="plane-type">{emptyLegList.return.Aircraft}</span>, etc
                </span>
                <span>
                  Seats:{' '}
                  {emptyLegList.return.SeatsRange.includes('-')
                    ? emptyLegList.return.SeatsRange.split('-')[0] ===
                      emptyLegList.return.SeatsRange.split('-')[1]
                      ? emptyLegList.return.SeatsRange.split('-')[0]
                      : emptyLegList.return.SeatsRange
                    : ''}
                </span>
              </div>
            </div>
            <div className="empty-price">
              <i className="bg-image"></i>
              {emptyLegList.return.Price ? (
                <span>
                  From<b>${divisionNumber(emptyLegList.return.Price)}</b>
                </span>
              ) : (
                <span>
                  <b>Ask for Price</b>
                </span>
              )}
              <button onClick={() => submitInquire('return')}>Inquire</button>
            </div>
          </div>
        </div>
      ) : null}

      {/* 未登录时补全用户信息 */}
      {addUserInfoShow && (
        <AddUserInfo
          type="emptyLeg"
          history={history}
          currentParams={currentParams}
          closeDialogHandle={closeDialogHandle}
          submitInquireAjax={submitInquireAjax}
        />
      )}
      {/* 填写手机号码弹窗&提交成功弹窗 */}
      {dialogType ? (
        <InquireDialog
          history={history}
          dialogType={dialogType}
          dialogContent={dialogContent}
          closeDialogHandle={closeDialogHandle}
          type="emptyLeg"
          submitInquire={submitInquire}
          inquireId={inquireId}
          routerId={routerId}
          sourceMenuShow={sourceMenuShow}
          showDialogHandle={showDialogHandle}
        />
      ) : null}
    </div>
  );
}
